"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UICaret;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconConstants = require("../IconConstants");

function UICaret(_ref) {
  var altText = _ref.altText,
      className = _ref.className,
      color = _ref.color,
      strokeWidth = _ref.strokeWidth,
      viewBoxHeight = _ref.viewBoxHeight,
      viewBoxWidth = _ref.viewBoxWidth,
      width = _ref.width,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["altText", "className", "color", "strokeWidth", "viewBoxHeight", "viewBoxWidth", "width"]);
  var viewBox = "0 0 " + viewBoxWidth + " " + viewBoxHeight;
  return _react.default.createElement("svg", Object.assign({}, rest, {
    className: (0, _classnames.default)('private-icon-caret', className),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox,
    width: width
  }), _react.default.createElement("title", null, altText), _react.default.createElement("path", {
    className: "private-icon-caret__inner",
    d: "M2 2l7.5 8.5-7.4 8.6",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth
  }));
}

UICaret.defaultProps = {
  strokeWidth: 4,
  viewBoxHeight: _IconConstants.CARET_HEIGHT,
  viewBoxWidth: _IconConstants.CARET_WIDTH
};
UICaret.propTypes = {
  altText: _propTypes.default.string,
  color: _propTypes.default.string,
  strokeWidth: _propTypes.default.number,
  viewBoxHeight: _propTypes.default.number,
  viewBoxWidth: _propTypes.default.number,
  width: _propTypes.default.number
};
UICaret.displayName = 'UICaret';
module.exports = exports.default;